<template>
  <div class="additional-emails" id="additional-email">
    <div class="section-header" id="popover-container">
      <div class="control-label-default w-100 no-margin-left">
        <span class="text-uppercase profile-header">{{ $t('PROFILE.notification.additionalEmail.title')}}</span>
        <span class="popover- margin-left-15" id="help-icon">
          <img class="help-icon" src="@/assets/images/common/info-btn.png" alt="help icon">
        </span>
        <div class="additional-tooltip">
          <b-tooltip container="popover-container" target="help-icon" triggers="hover focus" placement="top" offset="-40px">
            <i18n path="PROFILE.notification.additionalEmail.additionalPopover" tag="span">
              <span slot="not" class="italic">{{ $t('PROFILE.notification.additionalEmail.not')}}</span>
            </i18n>
          </b-tooltip>
        </div>
      </div>
    </div>
    
    <div class="email-section">
      <div class="email-wrapper d-flex" v-for="(item, i) in emails" :key="i">
        <div>
          <button class="btn btn-black-bkg btn-no-border delete-icon" v-b-tooltip.hover  v-b-modal.deleteEmailModal :title="$t('PROFILE.notification.additionalEmail.popoverDelete')" @click="emailId = item.id" >
            <img src="@/assets/images/icons/delete-icon.png" alt="delete-icon">
          </button>
        </div>
        <div class="confirmation-status">
          <button v-if="!item.confirmed" class="btn btn-black-bkg resend-confirmation" v-b-modal.resendEmailModal :class="{'disabled' : disableResend}" :disabled="disableResend"  v-b-tooltip.hover :title="$t('PROFILE.notification.additionalEmail.popoverConfirmation')" @click="emailId = item.id">
            <img src="@/assets/images/icons/reloading-white-arrow.png" alt="resend">
          </button>
        </div>
        <div>
          <p class="added-email">{{item.email}}</p>
          <p v-if="!item.confirmed" class="email-confirmation">* {{ $t('PROFILE.notification.additionalEmail.notConfirmed')}}</p> 
        </div>
      </div>
      
      <form class="email-wrapper form" novalidate v-show="showNewField" @submit.prevent="submitEmail">
        <input type="email" @change="checkIfEmailExists" v-model="email" v-validate="'required|email'" id="email" name="email" class="profile-input add-email-input" :class="{ 'error-input': submittedEmail && errors.has('email') }" />
        <button class="btn btn-black-bkg btn-no-border send-email" type="submit">
          <img src="@/assets/images/icons/confirm-icon.png" alt="confirm-icon">
        </button>
        <div v-if="submittedEmail && errors.has('email')" class="error error-message">
          {{ errors.first("email") }}
        </div>
        <div v-if="this.account.email == this.email" class="error error-message">
          {{ $t('PROFILE.notification.additionalEmail.sameEmail')}}
        </div>
        <div v-if="this.emailExists" class="error error-message">
          {{ $t('PROFILE.notification.additionalEmail.emailExists')}}
        </div>
        
      </form>
       <span v-show="!showNewField" class="add-more-wrapper">{{ $t('PROFILE.notification.additionalEmail.addNew')}}<b-btn class="plus-sign" @click="showNewField = true">+</b-btn></span>
    </div>

    <b-modal ref="deleteEmailModal" id="deleteEmailModal">
        <div slot="modal-header">
          <span class="modal-title">
            {{ $t('PROFILE.notification.additionalEmail.deleteEmail')}}
          </span>
        </div>
        <i18n path="PROFILE.notification.additionalEmail.modalConfirmationDel" tag="p" class="paragraph">
          <span slot="modalActionDel">{{ $t('PROFILE.notification.additionalEmail.modalActionDel')}}</span>
        </i18n>
        <div slot="modal-footer" class="w-100">
          <button type="button" class="btn btn-type-3" @click="closeDeleteConfirmationModal">{{ $t('PROFILE.notification.additionalEmail.cancel')}}</button>
          <button 
            type="button" 
            class="btn btn-type-4" 
           @click="deleteEmail(emailId)">
              <span class="button-content">
                {{ $t('PROFILE.notification.additionalEmail.confirm')}}
              </span>
            </button>
        </div>
      </b-modal>

      <b-modal ref="resendEmailModal" id="resendEmailModal">
        <div slot="modal-header">
          <span class="modal-title">
            {{ $t('PROFILE.notification.additionalEmail.resendEmail')}}
          </span>
        </div>
        <i18n path="PROFILE.notification.additionalEmail.modalConfirmation" tag="p" class="paragraph">
          <span slot="modalActionResend">{{ $t('PROFILE.notification.additionalEmail.modalActionResend')}}</span>
        </i18n>
        <div slot="modal-footer" class="w-100">
          <button type="button" class="btn btn-type-3" @click="closeResendConfirmationModal">{{ $t('PROFILE.notification.additionalEmail.cancel')}}</button>
          <button 
            type="button" 
            class="btn btn-type-4" 
           @click="resendEmail(emailId)">
              <span class="button-content">
                {{ $t('PROFILE.notification.additionalEmail.confirm')}}
              </span>
            </button>
        </div>
      </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { 
  ADD_ADDITIONAL_EMAIL,
  DELETE_ADDITIONAL_EMAIL,
  RESEND_ADDITIONAL_EMAIL } from '@/store/action.types'
import { TOASTER_SUCCESS, TOASTER_ERROR } from "@/common/events.types"
import STATUS_CODES from '@/common/statusCodes'
  
  export default {
  name: 'AdditionalEmail',
  
  data() {
    return {
     showNewField: false,
     email: '',
     emails: this.additionalEmails,
     emailId: '',
     submittedEmail: false,
     disableResend: false,
     emailExists: ''

    }
  },

  mounted() {
    this.emails = this.additionalEmails
  },

  watch:{
    account(newValue, oldValue) {
      this.emails = newValue.additionalEmailAddresses
    }
  },

  computed: {
    ...mapGetters([
      'account',
      'additionalEmails'
    ])
  },

  methods: {
    ...mapActions({
      addAdditionalEmail : ADD_ADDITIONAL_EMAIL,
      deleteAdditionalEmail : DELETE_ADDITIONAL_EMAIL,
      resendAdditionalEmail : RESEND_ADDITIONAL_EMAIL
    }),

    closeDeleteConfirmationModal () {
      this.$refs.deleteEmailModal.hide()
    },

    closeResendConfirmationModal () {
      this.$refs.resendEmailModal.hide()
    },

    checkIfEmailExists() {
      for(let i = 0; i < this.emails.length; i++) {
        if(this.emails[i].email == this.email) {
          this.emailExists =  true;
          break;
        }else {
          this.emailExists = false
        }
      }
      
    },

    submitEmail() {
      this.checkIfEmailExists()
      this.$validator.validate().then(result => {
      this.submittedEmail = true;
      if(result) {
        if(this.email.length && this.account.email != this.email && !this.emailExists) {
          this.addAdditionalEmail({
            playerId : this.account.playerId,
            email : this.email
          })
          .then((response) => {
            this.showNewField = false;
            this.emails = this.account.additionalEmailAddresses
            this.email = ''
            this.submittedEmail = false;
            this.emailExists = false;
            this.$eventHub.$emit(TOASTER_SUCCESS, {
              message: this.$t('PROFILE.toastMessages.addedEmail')
            })
          })
          .catch(({ status }) => {
            if (status.code === STATUS_CODES.BP_409) {
              this.$eventHub.$emit(TOASTER_ERROR, { message: this.$t('PROFILE.toastMessages.emailExists') })
            } else {
              this.$eventHub.$emit(TOASTER_ERROR, { message: this.$t('TOAST_MESSAGES.otherError') })
            }
            this.showNewField = false;
            this.email = '';
            this.submittedEmail = false;
            this.emailExists = false;
          })
        } 
      }
    })
    },

    deleteEmail(emailid) {
      this.closeDeleteConfirmationModal ()
      this.deleteAdditionalEmail({
        playerId: this.account.playerId,
        emailId : emailid
      })
      .then(() => {
        this.emails = this.additionalEmails
        this.$eventHub.$emit(TOASTER_SUCCESS, {
          message: this.$t('PROFILE.toastMessages.emailDeleted')
        });
      }) 
      .catch(({ status }) => {
        this.$eventHub.$emit(TOASTER_ERROR, { message: this.$t('TOAST_MESSAGES.otherError') })
      })
    },

    resendEmail(emailid) {
      this.closeResendConfirmationModal ()
      this.disableResend = true
      this.$root.$emit('bv::hide::tooltip')
      this.resendAdditionalEmail({
        playerId: this.account.playerId,
        emailId : emailid
      })
      .then(() => {
        this.$eventHub.$emit(TOASTER_SUCCESS, {
          message: this.$t('PROFILE.toastMessages.resendEmail')
        });
      }) 
      setTimeout(() => {
          this.disableResend = false;
      }, 30000);
    }
  }
}
</script>

<style lang="scss">  
.additional-emails {
  .tooltip-inner {
    background: #000000;
    padding: 15px;
    max-width: 320px;
    text-align: left;
  }
  .help-icon {
    width: 22px;
  }
}
  
  .email-section {
    padding-bottom: 30px;
    padding-left: 30px;
    .email-wrapper {
      margin-top: 10px;
      .resend-confirmation {
        background-color: $iron-gray-2;
        padding: 0 2px;
        img {
          width: 18px;
        }
        &:hover {
          background-color: $shark-gray-4;
        }
        &:focus {
          outline: none;
          box-shadow: none;
        }
        &[disabled] {
          background-color: $shark-gray-4;
          
        }
      }
      .added-email {
        color: $mid-gray;
        text-align: left;
        margin-left: 15px;
        display: inline-block;
        font-size: 14px;
        margin-bottom: 0;
      }
      .email-confirmation {
        font-size: 11px;
        margin-left: 15px;
        margin-bottom: 0;
        color: $mid-gray;
      }
      .confirmation-status {
        margin-left: 5px;
        font-size: 14px;
        color: $mid-gray;
        display: inline-block;
      }
      .btn-no-border {
        padding: 0 7px;
      }
    }
    .add-email-input{
      width: 60%;
      margin-top: 30px;
      border-radius: 0;
      height: auto;
    }
    .send-email {
      height: 44px;
      border-radius: 0;
      width: 45px;
      background-color: $iron-gray-2;
      position: relative;
      top: -1px;
      &:hover {
        background-color: $shark-gray-4;
      }
    }
    .delete-icon {
      &:hover {
        background-color: $shark-gray-4;
      }
    }
    .add-more-wrapper {
      display: inline-block;
      margin-top: 20px;
      .plus-sign {
        margin-left: 12px;
        border: 1px solid $mid-gray;
        outline: none;
        box-shadow: none;
        border-radius: 50%;
        background: $shark-gray;
        width: 25px;
        padding: 0;
      }
    }
  }

  @media screen and (max-width: 640px) { 
    .email-wrapper {
      .resend-confirmation {
        padding: 4px 7px !important;
      }
      .btn-no-border {
        padding: 5px 11px !important;
      }
      .confirmation-status {
        margin-left: 15px !important;
      }
      .add-email-input{
      width: calc(100% - 55px);
      }
    }
  }

</style>
